import { render } from "./campaignRow.vue?vue&type=template&id=e1e083a4&scoped=true"
import script from "./campaignRow.vue?vue&type=script&lang=js"
export * from "./campaignRow.vue?vue&type=script&lang=js"

import "./campaignRow.vue?vue&type=style&index=0&id=e1e083a4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1e083a4"]])

export default __exports__